<template lang="pug">
#services-footer.base-footer.col
  .base-footer__text
    h1.base-footer__title(v-for="item in title" v-html="item")
    p.base-footer__subtitle.base-footer__subtitle_desktop
      | Вдумчиво. Дорого. На совесть.
      br
      a(href="tel:+7 (800) 200 38 01").base-footer__link +7 800 200 38 01
      br
      a(href="mailto:order@nekidaem.ru").base-footer__link order@nekidaem.ru
      br
      | © 2010-{{ dt }}
    //- .social-media__wrapper
    //-     SocialLinksView
  Form(:value="formValue").base-footer__form
  p.base-footer__subtitle.base-footer__subtitle_mobile
    | Вдумчиво. Дорого. На совесть.
    br
    a(href="tel:+7 (800) 200 38 01").base-footer__link +7 800 200 38 01
    br
    a(href="mailto:order@nekidaem.ru").base-footer__link order@nekidaem.ru
    br
    | © 2010-{{ dt }}
</template>

<script>
export default {
  name: 'ServicesFooter',
  props: {
    formValue: {
      type: Object,
      required: true,
    },
    footerTitle: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    title() {
      return this.footerTitle.find(item => item.key === this.$route.params.slug)
        ? this.footerTitle.find(item => item.key === this.$route.params.slug).title
        : this.footerTitle.find(item => item.key === 'default').title
    },
    dt() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss" scoped>
.base-footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 100px 0 80px 0;

  @media (min-width: $breakpoint-medium) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (min-width: $breakpoint-xlarge) {
    padding: 280px 0 80px 0;
  }

  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    padding-left: 5vw;
    padding-right: 8vw;
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    padding-left: 0vw;
    padding-right: 1vw;
  }

  @media only screen and (width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    width: 80vw;
    margin: 0 auto;
  }

  &__text {
    margin-bottom: 0;
  }

  &__title {
    margin-bottom: 48px;
  }

  &__subtitle {
    color: $primary;
    font-weight: bold;

    &_mobile {
      margin-top: 80px;
    }

    &_desktop {
      display: none;
    }

    @media (min-width: $breakpoint-medium) {

      &_mobile {
        display: none;
      }

      &_desktop {
        display: block;
      }
    }
  }

  &__form {
    margin-top: 32px;

    @media (min-width: $breakpoint-medium) {
      // max-width: 300px;
      margin-top: 0;
    }
  }

  &__submitted {
    padding-top: 35px;
  }

  &__submitted-title {
    margin-bottom: 20px;
    color: $primary;
  }

  &__submitted-subtitle {
    color: $primary;
  }

  &__link {
    color: $primary;
    text-decoration: none;
  }
}

.social-media {
  &__wrapper {
    padding-top: 20px;
  }
}
</style>
